import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // o './styles.css' a seconda della tua struttura

// MVP 2026 — Self-Assessment / Knowledge Management: stili base (.card, .btn,
// .badge, .app-shell, ecc.) usati dalle pagine sotto src/features/. Le regole
// potenzialmente globali sono scoperte solo su .km-scope (vedi styles/global.css),
// quindi non toccano lo stile del resto del portale (Hub, Dashboard, Chat...).
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
